import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHeart,faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons';
import {faInstagram, faFacebookF, faLinkedinIn, faYoutube, faTwitter} from '@fortawesome/free-brands-svg-icons';
import '../styles/components/footer.css';

const endpoint = "https://files-website-fablab.s3.amazonaws.com/logosSubFooter/"

const logos_json = [
  {name : "logo_acreditacion.svg", url :"https://www.usm.cl/universidad/acreditacion/"},
  {name : "logo_acceso.svg", url :"https://acceso.mineduc.cl/"},
  {name : "logo_consejorectores.svg", url :"https://www.consejoderectores.cl/"},
  {name : "logo_g9.svg", url :"https://redg9.cl/"},
  {name : "logo_aur.svg", url :"https://www.auregionales.cl/"},
  {name : "logo_cruv.svg", url :"https://consejoderectoresvalparaiso.cl/"},
  {name : "logo_reuna.svg", url :"https://www.reuna.cl/"},
  {name : "logo_universia.svg", url :"https://www.universia.net/cl/home.html"},
]

export const Footer = () => {
    return (
      <>
        <Container fluid style={{backgroundColor: 'var(--blue)'}}>
          <Container className="footer">
            <Row className="white">    
                <Col xs={12} md={5}>
                    <h1 className="mb-3 footerTitle">Somos FabLab UTFSM</h1>
                    <p>Nuestro objetivo es entregar las herramientas y conocimiento a toda persona que se quiera educar, innovar e inventar usando tecnologías de fabricación digital, permitiéndoles que desarrollen prácticamente cualquier proyecto que puedan imaginar; dándoles la oportunidad de mejorar las vidas de las comunidades tanto de forma local como global.</p>
                    <a className="usm-text fablab-link white" href="https://www.usm.cl" target="_blank" rel="noreferrer">usm.cl</a>
                </Col>

                <Col xs={12} md={4}>
                    <h1 className="mb-3 footerTitle">¿Dónde estamos?</h1>
                    <h2 className="mb-3 footerSubtitle">Campus San Joaquín</h2>
                    <p><FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2"></FontAwesomeIcon> Av. Vicuña Mackenna 3939, San Joaquín, Santiago</p>                  
                </Col>

                <Col xs={12} md={3}>
                  <h1 className="mb-3 footerTitle">Sigue nuestras redes</h1>
                  <p>
                    <a href="https://www.facebook.com/fablabusm" target="_blank" rel="noreferrer"><FontAwesomeIcon className="footerBrands" border fixedWidth icon={faFacebookF}></FontAwesomeIcon></a>
                    <a href="https://twitter.com/fablab_utfsm" target="_blank" rel="noreferrer"><FontAwesomeIcon className="footerBrands" border fixedWidth icon={faTwitter}></FontAwesomeIcon></a>
                    <a href="https://www.youtube.com/channel/UCUGoYrG_0erOkSNy1VgMZgA" target="_blank" rel="noreferrer"><FontAwesomeIcon className="footerBrands" border fixedWidth icon={faYoutube}></FontAwesomeIcon></a>
                    <a href="https://www.instagram.com/fablab_utfsm/" target="_blank" rel="noreferrer"><FontAwesomeIcon className="footerBrands" border fixedWidth icon={faInstagram}></FontAwesomeIcon></a>
                    <a href="https://www.linkedin.com/company/fablab-utfsm/" target="_blank" rel="noreferrer"><FontAwesomeIcon className="footerBrands" border fixedWidth icon={faLinkedinIn}></FontAwesomeIcon></a>
                  </p>
                  <p>Creado con <FontAwesomeIcon icon={faHeart}></FontAwesomeIcon> por FabLab UTFSM</p>
                  <p>Desarrollado por <br></br>
                    <a className = "footerLink" href ="https://linkedin.com/in/jaime-rodríguez-45a69b195" target="_blank" rel="noreferrer"> Jaime Rodríguez</a>,
                    <a className = "footerLink" href ="https://linkedin.com/in/josue-venegas-almonacid" target="_blank" rel="noreferrer"> Josué Venegas</a>,
                    <a className = "footerLink" href ="https://linkedin.com/in/ben-espinoza-65388b20a" target="_blank" rel="noreferrer"> Ben Espinoza</a>
                  </p>
                </Col>      
            </Row>
          </Container>
        </Container>

        <Container fluid style={{backgroundColor: 'var(--gray)'}}>
          <Container className ="subfooter">
            <Row>
            <Col className="text-center">
              {
                logos_json.map(({name, url}) =>
                  <a key={name} target="_blank" rel="noreferrer" href ={url}> 
                    <img alt="" className="subfooterBrands" src={endpoint + name}></img>
                  </a>  
                )
              }
              </Col>
            </Row>
          </Container>
        </Container>
        </>
   );
}
